import { reducer as referencesReducer } from './model/references';

export * as ReferencesModel from './model';

export default referencesReducer;
